import React, { useState, useEffect } from 'react';
import { Tabs, Card, Row, Col, Button } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import ReadOnlyTextarea from '../../../../CSIComponents/ReadOnlyTextarea';
import DetailItem from '../../../../CSIComponents/DetailItem';
import { CalendarOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;
interface propsTypes {
    feesDetails: any,
    isEditable: void | any
    changeTab: void | any
}

const AMOUNT = 'Amount'

const FeesDetail = (props: propsTypes) => {
    const [detailData, setDetailData] = useState<{ label?: string, value?: string, span: number }[]>([]);
    const translateBoolean = (type: string) => type === 'true' ? 'Yes' : (type === 'false' ? 'No' : '')
    const toggleToEdit = () => {
        props.isEditable();
        props.changeTab('FeesEdit')
    }
    const detailDataForAmount = [
        { label: 'Application', value: props?.feesDetails?.application, span: 6 },
        { label: 'Type', value: props?.feesDetails?.type, span: 6 },
        { label: 'Charge Type', value: props?.feesDetails?.chargetype, span: 6 },
        { span: 5 },
        { label: 'Charge(Amount)', value: props?.feesDetails?.chargeamount, span: 6 },
        { label: 'Currency', value: props?.feesDetails?.currency, span: 6 },
        { label: 'Charge Frequency', value: props?.feesDetails?.chargefrequency, span: 6 },
        { span: 5 },
        { label: 'Charge Unit', value: props?.feesDetails?.chargeunit, span: 6 },
        { label: 'Mandatory', value: translateBoolean(props?.feesDetails?.mandatory), span: 6 },
        { label: 'Taxable', value: translateBoolean(props?.feesDetails?.taxable), span: 6 },
    ]

    const detailDataForPercent = [
        { label: 'Application', value: props?.feesDetails?.application, span: 6 },
        { label: 'Type', value: props?.feesDetails?.type, span: 6 },
        { label: 'Charge Type', value: props?.feesDetails?.chargetype, span: 6 },
        { span: 5 },
        { label: 'Charge(Percent)', value: props?.feesDetails?.chargeamount, span: 6 },
        { label: 'Charge Frequency', value: props?.feesDetails?.chargefrequency, span: 6 },
        { label: 'Charge Unit', value: props?.feesDetails?.chargeunit, span: 6 },
        { span: 5 },
        { label: 'Mandatory', value: translateBoolean(props?.feesDetails?.mandatory), span: 6 },
        { label: 'Taxable', value: translateBoolean(props?.feesDetails?.taxable), span: 6 },
    ]

    useEffect(() => {
        if (props?.feesDetails?.chargetype === AMOUNT) {
            setDetailData(detailDataForAmount)
        } else {
            setDetailData(detailDataForPercent)
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    
    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.changeTab('Fees') }}>Back</Button>
                    </div>
                    <div>
                        <Button type="primary" className="db-edit-btn" onClick={toggleToEdit}>Edit</Button>
                    </div>
                </div>
    } 

    return (
        <Tabs defaultActiveKey="detail">
            <TabPane tab="Detail" key="detail">
                <PageContainer>
                    <Card style={{ marginTop: -15 }} title={props?.feesDetails?.policycode} extra={edit()}>
                        <div style={{ padding: "0 20px" }}>
                            <Row gutter={24}>
                                <Col span={6} className="col-margin">
                                    <DetailItem value={props?.feesDetails?.policycode} label="Policy Code" />
                                </Col>
                                <Col span={12} className="col-margin">
                                    <div style={{ display: 'inline-block', width: '100%' }}>
                                        <div style={{ fontSize: 12, color: '#999999', height: '24px', "fontWeight": 600 }}>Start Date ~ End Date</div>
                                        <div style={{ display: 'flex', width: '100%', textOverflow: 'ellipsis', borderBottom: '1px solid #CCCCCC', padding: '0 5px', fontSize: '14px', height: '32px', marginTop: '5px', lineHeight: '32px', overflow: 'hidden', color: '#333333' }}>
                                            <div style={{ flex: 1 }}>{props?.feesDetails?.startdate}</div>
                                            <span style={{ padding: '0 10px', marginLeft: -20 }}>~</span>
                                            <div style={{ flex: 1 }}>{props?.feesDetails?.enddate}
                                                <CalendarOutlined style={{ float: 'right', marginTop: 10 }} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                {detailData.length !== 0 && detailData.map((item, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            {
                                                item.label ? <>
                                                    {
                                                        <Col span={item.span} key={i} className="col-margin">
                                                            <DetailItem value={item.value} label={item.label} style={{}} />
                                                        </Col>
                                                    }
                                                </> : <Col span={item.span} key={i}></Col>
                                            }
                                        </React.Fragment>
                                    )
                                })
                                }
                            </Row>
                            <Row gutter={24}>
                                <Col span={16}>
                                    <ReadOnlyTextarea value={props?.feesDetails?.description} label="Description" />
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </PageContainer>
            </TabPane>
        </Tabs>

    )
}

export default FeesDetail;

